import script from "./GameByUnity.vue?vue&type=script&setup=true&lang=js"
export * from "./GameByUnity.vue?vue&type=script&setup=true&lang=js"

import "./GameByUnity.vue?vue&type=style&index=0&id=41a715fa&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41a715fa"]])

export default __exports__